<template>
  <router-view />
</template>

<style lang="scss">
:root {
  --bg-color: white;
  --typewriterSpeed: 5s;
  --typewriterCharacters: 22;
  --bg-color-css: #f7d51d;
  --bg-color-scss: #209cee;
  --bg-color-js: #e76e55;
  --bg-color-vue: #92cc41;
  --bg-color-git: #21262d;
  --bg-color-more: #631c03;
  --bg-color-all: red;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main {
  margin: 5%;

  border-image: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="UTF-8" ?><svg version="1.1" width="5" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2 1 h1 v1 h-1 z M1 2 h1 v1 h-1 z M3 2 h1 v1 h-1 z M2 3 h1 v1 h-1 z" fill="rgb(33,37,41)" /></svg>');
  border-image-repeat: space;
  border-image-slice: 2;
  border-image-width: 2;
  border-image-outset: 2;
  border-style: solid;
  border-width: 4px;
  box-shadow: 4px 8px black, 0 0 black, 8px 4px black, 0 0 black;

  & .title {
    display: table;
    padding: 0 1rem;
    margin: -1.8rem 5rem 1rem;
    font-size: 1.5rem;
    background-color: #fff;
    text-transform: uppercase;
  }
}
</style>
